<template>
  <div>
    <label :for="name" class="block text-sm leading-5 font-medium text-gray-700"
      >{{ label }}<span v-if="required"> *</span></label
    >
    <div class="mt-1">
      <select
        :name="name"
        :id="id"
        :class="classComputed"
        v-bind:value="modelValue"
        v-on:input="$emit('update:modelValue', $event.target.value)"
        :disabled="disabled"
        :multiple="multiple"
        :tabindex="tabindex"
      >
        <option value="" v-if="emptyFirstOption">
          {{ emptyFirstOption }}
        </option>
        <option v-for="option in options" :value="option.value">
          {{ option.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  name: String,
  id: String,
  modelValue: [String, Number],
  label: String,
  options: Array,
  tabindex: Number,
  emptyFirstOption: String,
  error: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  multiple: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['update:modelValue']);

const classComputed = computed(() => {
  return {
    "shadow-sm": true,
    "focus:ring-primary-500": true,
    "focus:border-primary-500": true,
    block: true,
    "w-full": true,
    "sm:text-sm": true,
    "border-gray-300": true,
    "rounded-md": true,

    "border-red-500": props.error,
    "bg-gray-100": props.disabled,
    "text-gray-400": props.disabled,
  };
});
</script>
